import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const TrailerIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 36 21"
      children={
        // Copied from Trailer.svg
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.53659 0C0.687953 0 0 0.687953 0 1.53659V16.628H0.863339C1.17305 19.0426 3.236 20.9085 5.73476 20.9085C7.51328 20.9085 9.07102 19.9632 9.93293 18.5476C10.7948 19.9632 12.3526 20.9085 14.1311 20.9085C16.6299 20.9085 18.6928 19.0426 19.0025 16.628H20.6581L22.4451 14.2134H36V1.53659C36 0.687953 35.312 0 34.4634 0H1.53659ZM8.12195 15.997C8.12195 17.3154 7.05317 18.3841 5.73476 18.3841C4.41634 18.3841 3.34756 17.3154 3.34756 15.997C3.34756 14.6785 4.41634 13.6098 5.73476 13.6098C7.05317 13.6098 8.12195 14.6785 8.12195 15.997ZM14.1311 18.3841C15.4495 18.3841 16.5183 17.3154 16.5183 15.997C16.5183 14.6785 15.4495 13.6098 14.1311 13.6098C12.8127 13.6098 11.7439 14.6785 11.7439 15.997C11.7439 17.3154 12.8127 18.3841 14.1311 18.3841Z"
          fill="inherit"
        />
      }
    />
  )
}
